// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content {
  margin-top: 10px;
}

.bloc-ations {
  margin-top: 20px;
  margin-bottom: 20px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+document-request/request-template/request-template.component.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,mBAAA;AADJ;;AAGA;EACI,kCAAA;AAAJ","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n.page-content {\r\n    margin-top: 10px;\r\n}\r\n\r\n.bloc-ations {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n    background-color: white !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
